import styled from 'styled-components';

import { InputStructureProps } from './InputStructure';
import { ThemeMode } from '@/helpers/enums';

export const ScInputStructure = styled.div<Pick<InputStructureProps, 'mode'>>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;

  & input::placeholder {
    color: ${({ theme }) => theme.blackLightColor};
  }

  .content {
    position: relative;

    .addons {
      position: absolute;
      height: 100%;
      top: 0;
      right: 4px;
      display: flex;
      align-items: center;
      gap: 4px;

      & > svg {
        width: 32px;
        height: 32px;
        object-fit: contain;
      }
    }
  }

  & > .info,
  & > .error,
  & .content > .error {
    font-size: 12px;
    line-height: 18px;
    padding: 0 16px;
    position: relative;
  }

  & > .info {
    color: ${({ theme, mode }) =>
      mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
  }

  & .content > .error,
  & > .error {
    color: ${({ theme }) => theme.redColor};
  }
`;
